/**
 * SourceRepository — reads and writes the sources table. SQL only (rule R3).
 */

import type { SqliteClient } from '../adapters/sqlite-client';
import type { Source, SourceWithCount } from '../types';
import { toSource } from './row-mapping';

export class SourceRepository {
  constructor(private readonly db: SqliteClient) {}

  list(projectId: number): SourceWithCount[] {
    return this.db
      .all(
        `SELECT s.*, (SELECT COUNT(*) FROM media m WHERE m.source_id = s.id) AS item_count
           FROM sources s
          WHERE s.project_id = ?
          ORDER BY s.added_at ASC, s.id ASC`,
        [projectId],
      )
      .map((row) => ({ ...toSource(row), itemCount: Number(row.item_count ?? 0) }));
  }

  byId(id: number): Source | null {
    const row = this.db.get('SELECT * FROM sources WHERE id = ?', [id]);
    return row ? toSource(row) : null;
  }

  /** Folders are matched by name, so re-adding the same one reuses its row. */
  byName(projectId: number, name: string): Source | null {
    const row = this.db.get('SELECT * FROM sources WHERE project_id = ? AND name = ?', [
      projectId,
      name,
    ]);
    return row ? toSource(row) : null;
  }

  create(projectId: number, name: string, now: number): number {
    return this.db.run('INSERT INTO sources (project_id, name, added_at) VALUES (?, ?, ?)', [
      projectId,
      name,
      now,
    ]).lastId;
  }

  delete(id: number): void {
    this.db.run('DELETE FROM sources WHERE id = ?', [id]);
  }
}
